<template>
  <div v-if="sub_product != null">
    <!-- show feature image  -->
    <img v-if="sub_product.image && sub_img_product_prop  "
         class="product-feature-image"
         :src="subProductImage(product, sub_product.id)"
         :alt="findAttributeOnSiteInfo('site_name')[0]">

    <div v-if="calculatePriceAndOffer(product, sub_product.id)['price'] != null">
      <!--   price and offer    -->
      <div class="my-3">
        <del v-if="calculatePriceAndOffer(product, sub_product.id)['offer'] > 0">
          <h3 class="m-auto text-muted"
              v-html="$t('price.price', {currency: formatNumber(parseInt(calculatePriceAndOffer(product, sub_product.id)['price']))})">

          </h3>
        </del>
        <h2 class="m-auto"
            v-html="$t('price.price', {currency: formatNumber(parseInt(calculatePriceAndOffer(product, sub_product.id)['price'])  - calculatePriceAndOffer(product, sub_product.id)['offer'] )})">
        </h2>
      </div>

      <!--   quantity manager on authenticated shopping cart    -->
      <div v-if="checkProductOnShoppingCart(product,sub_product.id)">
        <m-shopping-cart-quantity-manager1 class=""

                                           :product="product"
                                           :sub_product="sub_product.id"/>
        <m-a :href="{name:shoppingCartLink()}">
          <button class="btn btn-primary rounded-pill" v-t="`product.single.shopping_cart`"></button>
        </m-a>
      </div>
      <!--   quantity manager on unauthenticated shopping cart    -->
      <div v-else>
        <div v-if="quantityChecker(1,product,sub_product.id)">

          <div class="my-2"
               v-if="findAttributeOnSiteInfo('product_unit_warning')[0] >= findProductQuantity(product,sub_product.id) && findProductQuantity(product,sub_product.id) != 0">
            <!--  show warning when product reach his limit    -->
            <p v-html="$t('product.quantity_warning', {quantity: findProductQuantity(product, sub_product.id)})"></p>
          </div>


          <div class="">
            <div class="" v-if="isCartTypeOnUnAuthenticated()">
              <button v-if="!checkProductOnShoppingCart(product,sub_product.id)"
                      @click="addToCartWrapper(product,sub_product.id)"
                      class="mt-4 btn rounded-pill row text-white btn-primary" v-t="`product.add_to_cart_physical`">
              </button>
            </div>
            <div class="mt-3" v-else>
              <m-a :href="{name:'Login'}">
                <div class="btn btn-primary" v-t="`product.single.register_button`"></div>
              </m-a>
              <p v-t="`product.single.register_button_description`"></p>
            </div>
          </div>

        </div>
        <div
            v-else-if="findSubProductOnProduct(product,sub_product.id) && !quantityChecker(1,product,sub_product.id)">
          <div class="btn btn-secondary" v-t="`product.out_of_quantity`"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="h4 btn btn-primary rounded-pill my-3" v-t="`product.callText`"></p>
    </div>


  </div>
</template>

<script>
import mA from "../../../Tags/A.vue";
import mShoppingCartQuantityManager1 from "../../ShoppingCartQuantityManager1.vue";
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "VariationQuantityManager1",
  components: {mShoppingCartQuantityManager1, mA},
  props: {
    sub_product: {
      default: null
    },
    product: {
      type: Object,
      required: true // باید شامل feature_product باشه
    },
    sub_img_product_prop:{
      default: true
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    ...shoppingCartFunctions,
    formatNumber,
    async addToCartWrapper() {
      // create this function to do some stuff after we add item to order
      await this.addToCart(...arguments)
      await this.refreshComponent()
    },
    refreshComponent() {
      this.$forceUpdate();
    },
  },
  mounted() {
    window.addEventListener('click', this.refreshComponent);
    window.addEventListener('DOMContentLoaded', this.refreshComponent);
  }
}
</script>

<style scoped>

</style>